import { data } from "autoprefixer";
import api from "../api";

export const getInvoices = (id, data) => {
  return api.getApi().get(api.getBaseUrl() + "payments/" + id + "/invoices", {
    params: {
      page: data.page,
      pageSize: data.pageSize,
      nameFilter: data.nameFilter,
      emailNameFilter: data.emailNameFilter,
      statusFilter: data.statusFilter,
      lucaIdFilter: data.lucaIdFilter,
      sortColumn: data.sortColumn,
      sortDirection: data.sortDirection,
    },
  });
};
export const getAllInvoices = (data) => {
  return api.getApi().get(api.getBaseUrl() + "invoices-all", {
    params: {
      page: data.page,
      pageSize: data.pageSize,
      nameFilter: data.nameFilter,
      emailNameFilter: data.emailNameFilter,
      statusFilter: data.statusFilter,
      lucaIdFilter: data.lucaIdFilter,
      countryFilter: data.countryFilter,
      maxAmount: data.maxAmount,
      minAmount: data.minAmount,
      sortColumn: data.sortColumn,
      sortDirection: data.sortDirection,
    },
  });
};
export const getAllInvoicesOperations = (data) => {
  return api.getApi().get(api.getBaseUrl() + "invoices-operations", {
    params: {
      page: data.page,
      pageSize: data.pageSize,
      nameFilter: data.nameFilter,
      emailNameFilter: data.emailNameFilter,
      statusFilter: data.statusFilter,
      lucaIdFilter: data.lucaIdFilter,
      countryFilter: data.countryFilter,
      managerNameFilter: data.managerNameFilter,
      relatedUserFilter: data.relatedUserFilter,
      sortColumn: data.sortColumn,
      sortDirection: data.sortDirection,
    },
  });
};
export const getInvoice = (id, commissionDetailId) => {
  return api
    .getApi()
    .get(
      api.getBaseUrl() + "payments/" + id + "/invoices/" + commissionDetailId
    );
};
export const updateInvoice = (id, data) => {
  return api.getApi().put(api.getBaseUrl() + "invoices/" + id, data);
};

export const approveInvoice = (data) => {
  console.log("data", data);
  console.log("data.id", data.id);
  return api
    .getApi()
    .put(api.getBaseUrl() + `invoices/${data.id}/approve`, { data: data.data });
};

export const downloadInvoicesExcel = (id) => {
  console.log("id", id);
  return api
    .getApiForBlob()
    .get(api.getBaseUrl() + "payments/" + id + "/invoices/downloadAll");
};

export const downloadFilteredInvoicesExcel = (id, params) => {
  return api.getApi().get(api.getBaseUrl() + `payments/${id}/excelDownload`, {
    params,
    responseType: "blob",
  });
};
export const downloadFilteredInvoicesAllExcel = (params) => {
  return api.getApi().get(api.getBaseUrl() + `invoices-all/excelDownload`, {
    params,
    responseType: "blob",
  });
};
export const downloadFilteredInvoicesAllBankExcel = (params) => {
  return api.getApi().get(api.getBaseUrl() + `invoices-all/bankExcelDownload`, {
    params,
    responseType: "blob",
  });
};
export const uploadInvoiceStatusExcel = (data) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `excels/invoicesUploadStatus`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
};

export const uploadBulkPaymentExcel = (data) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `excels/paidAndUpdateStatus`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
};

export const deleteCommissionDetail = (id) => {
  return api.getApi().delete(api.getBaseUrl() + `invoices/${id}`);
};

export const getPaymentHistoryGroups = (data) => {
  return api.getApi().get(api.getBaseUrl() + `payment-history/groups`, {
    params: {
      page: data.page,
      pageSize: data.pageSize,
      countryFilter: data.countryFilter,
    },
  });
};

export const getPaymentHistoryByGroupId = (groupId) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `payment-history/group/${groupId}`);
};

export const downloadGroupInvoicePdfs = (groupId) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `payment-history/group/${groupId}/download-pdfs`, {
      responseType: "blob",
    });
};

export const getCommissionCountryGroupedInvoiceIds = (country) => {
  return api
    .getApi()
    .get(
      api.getBaseUrl() + `commission-country-grouped-invoice-ids/${country}`
    );
};

export const getCommissionsForReminderTool = (country, mailType) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `commissions-for-reminder-tool/${country}`, {
      mailType,
    });
};

export const sendBulkReminderMails = (country, data) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `send-bulk-reminder-mails/${country}`, data);
};

export const markPaymentAsNotPaid = (paymentHistoryId) => {
  return api
    .getApi()
    .put(
      api.getBaseUrl() + `payment-history/${paymentHistoryId}/mark-not-paid`
    );
};

export const markPaymentAsReturn = (paymentHistoryId, reason) => {
  return api
    .getApi()
    .put(api.getBaseUrl() + `payment-history/${paymentHistoryId}/mark-return`, {
      reason,
    });
};

// İstisna belgesi (PDF ya da görsel) - auth korumalı proxy üzerinden
export const getExemptionDocument = (commissionDetailId) => {
  return api
    .getApiForBlob()
    .get(api.getBaseUrl() + `invoices/${commissionDetailId}/exemption-document`);
};

export const getInvoicePdf = (commissionDetailId) => {
  return api
    .getApiForBlob()
    .get(api.getBaseUrl() + `invoices/${commissionDetailId}/pdf`);
};
